import type { FormEvent } from 'react';
import React from 'react';

import { AdornedInput, Adornment, FormField, Input, Label } from '@zillow/constellation';

import PropertyType_v1 from './PropertyType_v1';
import type { Section } from '../../../models/index';
import { PROPERTY_TYPE } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  setSection: (section: Section) => void;
};

function PropertyType_v4({ section, setSectionValues, setSection }: Props): JSX.Element {
  function setNumberOfUnits(e: FormEvent<HTMLInputElement>): void {
    setSectionValues({ [PROPERTY_TYPE.FIELD_NAME.NUMBER_OF_UNITS]: e.currentTarget.value });
  }

  const isMultiFamily = section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY);

  return (
    <PropertyType_v1 {...{ section, setSectionValues, setSection }}>
      {isMultiFamily && (
        <>
          <FormField
            label={<Label>How many unit(s) does the property have?</Label>}
            control={
              <AdornedInput
                rightAdornment={<Adornment>unit(s)</Adornment>}
                input={
                  <Input
                    type="number"
                    value={section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.NUMBER_OF_UNITS)}
                    onChange={setNumberOfUnits}
                  />
                }
              />
            }
          />
        </>
      )}
    </PropertyType_v1>
  );
}

export default PropertyType_v4;

PropertyType_v4.description = 'Asks for number of units';
